import React from 'react';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-8 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden min-h-screen flex flex-col items-center justify-center" data-id="element-61">
      {/* Background image with blur */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/jdbueeo4Gmie8SsmAq4yPs/Firefly_Gemini_Flash_Sacale_el_texto_119180.png')`,
      filter: 'blur(3px)',
      transform: 'scale(1.05)'
    }} data-id="element-62" />
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-[#0d1f35]/70" data-id="element-63" />

      <div className="relative z-10 max-w-6xl mx-auto text-center" data-id="element-64">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/30 text-white px-6 py-2.5 rounded-full mb-8 shadow-lg" data-id="element-65">
          <Star className="w-5 h-5 text-[#d4a853] fill-[#d4a853]" data-id="element-66" />
          <span className="font-semibold text-sm sm:text-base tracking-wide" data-id="element-67">
            Sistema completo para docentes argentinos
          </span>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white tracking-tight mb-8 leading-none drop-shadow-lg" data-id="element-68">
          POLÍTICA Y CIUDADANÍA 360
        </h1>

        {/* Product Mockup */}
        <div className="relative mx-auto max-w-4xl mb-10 cursor-pointer group" onClick={() => document.getElementById('comprar')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-69">
          <img src="https://cdn.magicpatterns.com/uploads/3MdZ6pAmuJnbfB4t6UavwB/MOCKUP_PRINCIPAL_POLITICA_Y_CIUDADANIA.png" alt="Política y Ciudadanía 360 - Pack completo para docentes" className="relative w-full object-contain transform transition duration-500 group-hover:scale-[1.02] drop-shadow-2xl" data-id="element-70" />
        </div>

        {/* Subtitle */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight drop-shadow-md" data-id="element-71">
          <span className="italic" data-id="element-72">ORGANIZA TU AÑO DE</span>
          <br data-id="element-73" />
          <span className="text-[#d4a853] italic" data-id="element-74">
            POLÍTICA Y CIUDADANÍA SIN ESTRÉS
          </span>
        </h2>

        {/* Description */}
        <p className="text-lg sm:text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-75">
          Sistema completo de proyectos, experiencias y evaluaciones listas para
          usar.
          <br className="hidden sm:block" data-id="element-76" />
          <strong className="text-[#d4a853]" data-id="element-77">
            Todo tu año de Política y Ciudadanía resuelto en un clic.
          </strong>
        </p>

        {/* CTA Button */}
        <Button className="text-xl px-10 py-5 w-full sm:w-auto shadow-xl" data-id="element-78">
          QUIERO ORGANIZAR MI AÑO AHORA
        </Button>
      </div>
    </section>;
}